import { AvatarFallback, AvatarImage, Avatar as ShadcnAvatar } from '@/components/ui/avatar'
import { cn, getInitials } from '@/lib/utils'

const SIZE_MAP: Record<number, string> = {
  3: 'h-3 w-3',
  3.5: 'h-3.5 w-3.5',
  4: 'h-4 w-4',
  5: 'h-5 w-5',
  6: 'h-6 w-6',
  8: 'h-8 w-8',
  10: 'h-10 w-10',
  12: 'h-12 w-12',
  16: 'h-16 w-16',
  20: 'h-20 w-20',
} as const

interface AvatarProps {
  size?: keyof typeof SIZE_MAP
  imageSrc?: string
  name: string
  maxInitialsLength?: number
  className?: string
  props?: React.ComponentProps<typeof ShadcnAvatar>
}

export function Avatar({ size = 8, className, ...rest }: AvatarProps) {
  const sizeClass = SIZE_MAP[size]
  return (
    <ShadcnAvatar className={cn(sizeClass, className)} {...rest}>
      <AvatarImage src={rest.imageSrc} alt={rest.name} />
      <AvatarFallback className={sizeClass} style={{ fontSize: `${size * 2}px` }}>
        {getInitials(rest.name, rest.maxInitialsLength)}
      </AvatarFallback>
    </ShadcnAvatar>
  )
}
